/** @jsxImportSource react */
import { bool, func, node } from 'proptypes';
import React, { useCallback, useLayoutEffect, useRef } from 'react';

const Popover = ({ onClose, isOpen, children, ...props }) => {
  const blockRef = useRef();

  const onDocumentClick = useCallback(
    (event) => {
      if (
        isOpen &&
        document.contains(event.target) &&
        !blockRef.current.contains(event.target)
      ) {
        onClose();
      }
    },
    [isOpen, onClose]
  );

  const onKeyUp = useCallback(
    (event) => {
      if (isOpen && event.code === 'Escape') {
        onClose();
      }
    },
    [isOpen, onClose]
  );

  useLayoutEffect(() => {
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keyup', onKeyUp);
    return () => {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keyup', onKeyUp);
    };
  }, [onDocumentClick, onKeyUp]);

  return (
    <div
      ref={blockRef}
      className='shadow-[rgb(0 0 0 / 20%) 0px 4px 8px] rounded-box z-[2001] w-[360px] rounded-[4px] bg-white'
      {...props}
      data-tp-id='gen-div-31cde678-b362-4b70-920a-4b9a93966a21'
    >
      {children}
    </div>
  );
};

Popover.propTypes = {
  onClose: func,
  isOpen: bool,
  children: node,
};

export default Popover;
